// extracted by mini-css-extract-plugin
module.exports = {"raffleGrid":"pages--raffle-grid--17na3"};